import { useEffect, useState } from 'react';
import SideBar from './SideBar';
import HeaderSection from './HeaderSection';
import SuperAdminStatsDashboard from './components/SuperAdminStatsDashboard';

export default function AdminDashboard() {
    const [canViewStatsDashboard, setCanViewStatsDashboard] = useState(false);

    useEffect(() => {
        try {
            const storedUser = sessionStorage.getItem('user_detail');
            if (!storedUser) return;
            const parsedUser = JSON.parse(storedUser);
            const userType = String(parsedUser?.user_type || '').toLowerCase();
            // Keep dashboard hidden only for customers.
            setCanViewStatsDashboard(
                userType === 'admin' ||
                userType === 'super admin' ||
                userType === 'super_admin' ||
                userType === 'superadmin'
            );
        } catch (error) {
            setCanViewStatsDashboard(false);
        }
    }, []);

    return (
        <div className="container-scroller admin-dashboard-page">
                <SideBar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <HeaderSection />
                        {!canViewStatsDashboard ? (
                            <div className="card border-0 shadow-sm">
                                <div className="card-body">
                                    <h5 className="mb-1">Super Admin Dashboard</h5>
                                    <p className="mb-0 text-muted">
                                        This section is not available for customers.
                                    </p>
                                </div>
                            </div>
                        ) : (
                            <SuperAdminStatsDashboard />
                        )}
                    </div>
                </div>
            </div>
    );
}
